import { SxProps, Theme } from "@mui/material";

export const paymentCheckoutModalStyles = {
    modalOverlay: (theme: Theme): SxProps<Theme> => ({
        fontFamily: theme.typography.fontFamily,
    }),
    modalContent: {
        height: "85%",
        pt: 3,
        pb: 1,
        px: 2,
    },
    crossIcon: {
        width: "16px",
        cursor: "pointer",
    },
      loaderContainer: {
        backgoundColor: "rgba(132, 129, 129, 0.8)",
    position: "fixed",
    top: 0,
    zIndex: 999,
    left: 0,
    width: "100%",
    height: "95vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
    title: (theme: Theme): SxProps<Theme> => ({
        fontSize: 24,
        fontWeight: 700,
        mb: 2,
        fontFamily: theme.typography.fontFamily,
    }),
    inputContainer: {
        mb: 2,
    },
    inputLabel: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 600,
        fontSize: 13,
        marginBottom: "2px",
        fontFamily: theme.typography.fontFamily,
    }),
    textField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            padding: "0px",
        },
        "& .MuiOutlinedInput-input": {
            fontSize: "13px",
            padding: "12px !important",
        },
    },
    applePayButtonContainer: {
        mb: 2,
    },
    cardElementContainer: {
        border: "1px solid #000",
        fontSize: "13px",
        padding: "12px !important",
        borderRadius: "12px",
    },
    divider: {
        borderColor: "#8D8D8D",
        borderWidth: "0.2px",
        marginTop: "25px",
    },
    paymentSection: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 2.5,
    },
    priceText: (theme: Theme): SxProps<Theme> => ({
        fontSize: 22,
        fontWeight: 600,
        lineHeight: "30px",
        letterSpacing: "0.081px",
        width: "fit-content",
        fontFamily: theme.typography.fontFamily,
    }),
    feeText: (theme: Theme): SxProps<Theme> => ({
        fontSize: 13,
        fontWeight: 400,
        lineHeight: "18.5px",
        letterSpacing: "0.203px",
        width: "fit-content",
        color: "#0D0D0D",
        fontFamily: theme.typography.fontFamily,
    }),
    paymentButton: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: "#328734",
        color: "#fff",
        fontSize: 17,
        fontFamily: theme.typography.fontFamily,
        padding: "12px 18px",
        borderRadius: "8px",
        "&:hover": {
            backgroundColor: "#28702d",
        },
    }),
    footerContainer: {
        mt: 2.5,
        textAlign: "center",
    },
    footerText: (theme: Theme): SxProps<Theme> => ({
        fontSize: 13,
        color: "#000",
        fontWeight: 400,
        lineHeight: "18.5px",
        letterSpacing: "0.203px",
        fontFamily: theme.typography.fontFamily,
    }),
    logo: {
        margin: "auto",
    },
};


export const stripeCardElementOptions = {
    style: {
        base: {
            fontSize: "16px",
        },
    },
};